import { SidebarHeader } from "./SidebarHeader";
import { SidebarNavigation } from "./SidebarNavigation";

interface SidebarContentProps {
  pathname: string;
  isAdmin: boolean;
  isCollapsed: boolean;
  toggleSidebar: () => void;
  setIsMenuOpen: (value: boolean) => void;
  isMobile: boolean;
}

/**
 * Sidebar Content.
 */
export function SidebarContent({
  isCollapsed,
  toggleSidebar,
  setIsMenuOpen,
  isMobile,
}: Readonly<SidebarContentProps>) {
  return (
    <div className={`flex flex-col h-full w-full ${isMobile ? "max-h-screen" : "min-h-screen"}`}>
      <SidebarHeader isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} isMobile={isMobile} />

      <div className="flex-grow flex flex-col overflow-y-auto w-full scrollbar-thin scrollbar-thumb-muted scrollbar-track-transparent">
        <SidebarNavigation
          isCollapsed={isCollapsed}
          setIsMenuOpen={setIsMenuOpen}
          isMobile={isMobile}
          toggleSidebar={toggleSidebar}
        />

        {/* Subtle gradient at bottom */}
        <div className="mt-auto h-4 bg-gradient-to-t from-background to-transparent pointer-events-none" />
      </div>
    </div>
  );
}
